var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconnewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 37.5H32.5V22.5H40L30 10L20 22.5H27.5V37.5Z",
    fill: "#11183F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45H10V27.5H5V45C5 47.7575 7.2425 50 10 50H50C52.7575 50 55 47.7575 55 45V27.5H50V45Z",
    fill: "#11183F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconnewDark);
export default __webpack_public_path__ + "static/media/iconnewDark.f4263ff02e2bc73d40f631d213edceb7.svg";
export { ForwardRef as ReactComponent };